// import "./App.css";
import React from "react";

import { Viewer } from "./components/Viewer";
import { InfoPanel } from "./components/InfoPanel";
import { HeaderBar } from "./components/HeaderBar";

export default function App() {
    return (
        <div style={{ height: "100vh" }}>
            <HeaderBar />
            <Viewer height="50%" />
            <InfoPanel />
        </div>
    );
}
